module.exports = __webpack_public_path__ + "img/bgc@2x.983c737e.png";